"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getAnnotation = exports.getLabelSizing = exports.getNonAbbrevLabel = exports.forceLabels = exports.getDrawParams = exports.getResolvedChartStyle = void 0;
const lodash_1 = __importDefault(require("lodash"));
const canvas_1 = require("canvas");
const chartStyles_1 = __importDefault(require("./chartStyles"));
const constants_1 = require("./constants");
const chart_helpers_1 = require("../../util/chart.helpers");
const common_module_scss_1 = __importDefault(require("../../styles/common.module.scss"));
const getResolvedChartStyle = (styleString, chartStyleOptions) => {
  const resolvedChartStyle = chartStyles_1.default[styleString] || chartStyles_1.default.default;
  return Object.assign(resolvedChartStyle, chartStyleOptions);
};
exports.getResolvedChartStyle = getResolvedChartStyle;
const getDrawParams = _ref => {
  let {
    data,
    parent,
    options: {
      annotations = [],
      annotateEnd = false,
      annotationColour = null,
      annotationColourEnd = null,
      areaFill = false,
      axisTextColor = common_module_scss_1.default.chartAxisFontColor,
      boldValueLabels = true,
      chartStyle = 'default',
      chartStyleOptions = {},
      circlesVisible = false,
      gridColor = null,
      heightToWidthRatio = null,
      hideAxisLabels = false,
      hideGridlines = false,
      hideLineLabels = false,
      hideTitle = false,
      hideTooltip = false,
      highlighted = [],
      intro = false,
      labelOpacities = null,
      labelTextMode = null,
      lineSize = null,
      primaryColor = null,
      showLastPoint = false,
      // null for auto legend
      showLegend = null,
      showSourcesAndFootnotes = true,
      showXGridlines = false,
      showZeroLine = false,
      smallSubtitleColor = null,
      smallTitleColor = null,
      tooltipOnTap = true,
      tooltipOptions = {},
      transition = false,
      useStateAbbreviations = false,
      xDomain = null,
      xTickFormat = null,
      xValues = null,
      yDomain = null,
      yValueExtraLabels = null,
      yValueLabels = null,
      yValues = null,
      ...otherOptions
    }
  } = _ref;
  const resolvedChartStyle = (0, exports.getResolvedChartStyle)(chartStyle, chartStyleOptions);
  return {
    ...(0, chart_helpers_1.getDefaultDrawParams)({
      data,
      parent,
      options: otherOptions
    }, resolvedChartStyle.margins || chartStyles_1.default.default.margins),
    annotations,
    annotationColour,
    annotateEnd,
    annotationColourEnd,
    areaFill,
    axisTextColor,
    boldValueLabels,
    chartStyle: resolvedChartStyle,
    circlesVisible,
    gridColor,
    heightToWidthRatio,
    hideAxisLabels,
    hideGridlines,
    hideLineLabels,
    hideTitle,
    hideTooltip,
    highlighted,
    intro,
    labelOpacities,
    labelTextMode,
    lineSize,
    primaryColor,
    showXGridlines,
    showLastPoint,
    showLegend,
    showSourcesAndFootnotes,
    showZeroLine,
    smallTitleColor,
    smallSubtitleColor,
    tooltipOnTap,
    tooltipOptions,
    transition,
    useStateAbbreviations,
    xDomain,
    xTickFormat,
    xValues,
    yDomain,
    yValueExtraLabels,
    yValueLabels,
    yValues
  };
};
exports.getDrawParams = getDrawParams;
const forceLabels = function (data) {
  let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  const {
    fontSize = 16,
    padding = 2,
    pushBy = 2,
    minY = 0,
    maxY = 500,
    labelLineHeight
  } = options;
  // 2000 iterations should be an overestimate, but prevents us from getting
  // stuck in an infinite loop
  let iterations = 2000;
  let positionData = lodash_1.default.map(data, _ref2 => {
    let {
      y,
      text,
      ...rest
    } = _ref2;
    return {
      y,
      text,
      ...rest
    };
  });
  function getTextHeight(text) {
    if (Array.isArray(text)) {
      return fontSize + 2 * padding + (text.length - 1) * fontSize * labelLineHeight;
    }
    return fontSize + 2 * padding;
  }
  const pushLabels = (_ref3, i) => {
    let {
      y,
      text,
      ...rest
    } = _ref3;
    let pushDown = 0;
    let pushUp = 0;
    positionData.forEach((_ref4, j) => {
      let {
        y: y2,
        text: text2
      } = _ref4;
      if (i === j) {
        return;
      }
      const minDist = (getTextHeight(text) + getTextHeight(text2)) / 2;
      const dy = y - y2;
      if (dy > 0 && dy < minDist) {
        pushDown = Math.max(Math.min(pushBy, minDist - dy), pushDown);
      }
      if (dy < 0 && -dy < minDist) {
        pushUp = Math.min(Math.max(-pushBy, -minDist - dy), pushUp);
      }
      if (dy === 0) {
        if (i < j) {
          pushUp = Math.min(Math.max(-pushBy, -minDist), pushUp);
        } else {
          pushDown = Math.max(Math.min(pushBy, minDist), pushDown);
        }
      }
    });
    return {
      pushDown,
      pushUp,
      y: pushUp === 0 || pushDown === 0 ? y + pushDown + pushUp : y + (pushUp + pushDown) / 2,
      text,
      ...rest
    };
  };
  do {
    positionData = positionData.map(pushLabels);
    iterations -= 1;
  } while ((0, lodash_1.default)(positionData).map(_ref5 => {
    let {
      pushUp,
      pushDown
    } = _ref5;
    return Math.abs(pushUp) + Math.abs(pushDown);
  }).sum() > 0 && iterations > 0);
  if (maxY !== undefined) {
    let prevMax;
    positionData = (0, lodash_1.default)(positionData).sortBy('y').reverse().map(d => {
      const textHeight = getTextHeight(d.text);
      let {
        y
      } = d;
      // let y = d.y;
      if (prevMax === undefined) {
        prevMax = maxY + textHeight / 2;
      }
      if (d.y + textHeight / 2 > prevMax) {
        prevMax -= textHeight / 2;
        y = prevMax;
        prevMax -= textHeight / 2;
      }
      return {
        ...d,
        y
      };
    });
  }
  if (minY !== undefined) {
    let prevMin = minY;
    positionData = (0, lodash_1.default)(positionData).sortBy('y').map(d => {
      const textHeight = getTextHeight(d.text);
      let {
        y
      } = d;
      if (d.y - (textHeight - (fontSize + 2 * padding)) / 2 < prevMin) {
        prevMin += textHeight / 2;
        y = prevMin;
        prevMin += textHeight / 2;
      }
      return {
        ...d,
        y
      };
    });
  }
  return positionData.map(p => ({
    ...p,
    y: p.y - (getTextHeight(p.text) - (fontSize + 2 * padding)) / 2
  }))
  // sort back into data order
  .sortBy('sortIndex');
};
exports.forceLabels = forceLabels;
const getNonAbbrevLabel = (d, isSubchart, mode) => {
  if (d.labelText !== undefined) {
    return d.labelText;
  }
  if (mode === 'states') {
    return d.metric.geo_name;
  }
  if (mode === 'metrics') {
    return d.metric.name;
  }
  if (mode === 'categories') {
    return d.metric.geo_name;
  }
  if (isSubchart && d.metric.lexiconName !== undefined) {
    return d.metric.lexiconName;
  }
  if (!isSubchart && d.metric.geo_name && d.metric.geo_id !== 'US') {
    return d.metric.geo_name;
  }
  return d.metric.name;
};
exports.getNonAbbrevLabel = getNonAbbrevLabel;
const getLabelSizing = function (labels, maxWidth) {
  let startFontSize = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 16;
  let startFontWeight = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '600';
  let fontFamily = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : common_module_scss_1.default.mainFontFamily;
  let minFontSize = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : startFontSize;
  const context = (0, canvas_1.createCanvas)(500, 500).getContext('2d');
  let fontSize = startFontSize;
  const fontWeight = startFontWeight;
  context.font = `${fontWeight} ${fontSize}px ${fontFamily}`;
  let width = (0, lodash_1.default)(labels).map(label => context.measureText(label).width).max();
  if (width > maxWidth - constants_1.LABEL_PADDING) {
    while (width > maxWidth - constants_1.LABEL_PADDING && fontSize > minFontSize) {
      fontSize -= 1;
      context.font = `${fontWeight} ${fontSize}px ${fontFamily}`;
      width = (0, lodash_1.default)(labels).map(label => context.measureText(label).width).max();
    }
  }
  return {
    width: Math.min(width, maxWidth),
    fontSize,
    fontWeight
  };
};
exports.getLabelSizing = getLabelSizing;
// eslint-disable-next-line default-param-last
const getAnnotation = function () {
  let annotations = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  let key = arguments.length > 1 ? arguments[1] : undefined;
  let metricID = arguments.length > 2 ? arguments[2] : undefined;
  let xType = arguments.length > 3 ? arguments[3] : undefined;
  let annotation = arguments.length > 4 ? arguments[4] : undefined;
  const paramAnnotation = annotations.find(_ref6 => {
    let {
      metric,
      key: annotationKey
    } = _ref6;
    return metric === metricID && key.getTime() === (0, chart_helpers_1.dateParser)(annotationKey, xType).getTime();
  });
  if (!lodash_1.default.isNil(paramAnnotation)) {
    return {
      ...paramAnnotation,
      key
    };
  }
  if (lodash_1.default.isString(annotation)) {
    return {
      title: annotation,
      metric: metricID,
      key
    };
  }
  if (lodash_1.default.isObject(annotation)) {
    return {
      annotation,
      metric: metricID,
      key
    };
  }
  return null;
};
exports.getAnnotation = getAnnotation;